// EmbroideryViewer.jsx

import React, { Component } from "react";
import "./embroideryviewer.css";

import {
  FaCloudUploadAlt,
  FaLayerGroup,
  FaClock,
  FaMoneyBillWave,
} from "react-icons/fa";

import { GiSewingMachine, GiSewingNeedle } from "react-icons/gi";

class EmbroideryViewer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      preview: null,
      rpm: 700,
      pricePer10k: 50,
      loading: false,
    };
  }

  handleFile = async (e) => {
    const file = e.target.files[0];

    if (!file) return;

    const extension = file.name?.split(".")?.pop()?.toLowerCase();

    const allowedFormats = [
      "dst",
      "jef",
      "pes",
      "exp",
      "vp3",
      "xxx",
      "pec",
      "hus",
      "sew",
    ];

    if (!allowedFormats.includes(extension)) {
      alert("Unsupported embroidery format");

      return;
    }

    try {
      this.setState({
        loading: true,
      });

      const formData = new FormData();

      formData.append("file", file);

      const response = await fetch(
        "https://jccreations.boutique/api/embroidery/upload-metadata",
        {
          method: "POST",
          body: formData,
        },
      );

      const data = await response.json();

      if (!data.success) {
        alert("Failed to render embroidery file");

        this.setState({
          loading: false,
        });

        return;
      }

      this.setState({
        preview: {
          fileName: file.name,

          stitches: data.design.stitchCount,

          colors: data.design.colorCount,

          trims: data.design.trimCount,

          jumps: data.design.jumpCount,

          width: data.design.width,

          height: data.design.height,

          image: data.design.previewPngUrl,
        },

        loading: false,
      });
    } catch (error) {
      console.log(error);

      alert("Server error");

      this.setState({
        loading: false,
      });
    }
  };

  mmToInch = (mm) => {
    if (!mm) return 0;
    return (mm / 25.4).toFixed(2);
  };

  render() {
    const { preview } = this.state;

    return (
      <div className="embroidery-viewer-page">
        {/* HEADER */}
        <div className="ev-header">
          <div className="ev-header-content">
            <h1>JC CREATIONS EMBROIDERY VIEWER</h1>

            <p>
              Professional embroidery design visualization and stitch estimation
            </p>
          </div>
        </div>

        <div className="ev-body">
          {/* TOP ACTIONS */}
          <div className="ev-upload-row">
            <label className="ev-upload-btn">
              <FaCloudUploadAlt size={18} />

              <span>Upload Design</span>

              <input
                type="file"
                hidden
                accept=".dst,.pes,.jef,.exp,.vp3,.hus,.pec,.xxx"
                onChange={this.handleFile}
              />
            </label>

            {preview && (
              <button
                className="ev-clear-btn"
                onClick={() =>
                  this.setState({
                    preview: null,
                  })
                }
              >
                ✕
              </button>
            )}
          </div>

          {/* BEFORE UPLOAD */}
          {!preview && (
            <div className="ev-empty-layout">
              {/* LEFT */}
              <div className="ev-empty-card">
                <div className="ev-empty-icon">
                  <GiSewingMachine />
                </div>

                <h3>No Design Selected</h3>

                <p>
                  Upload embroidery design files to preview stitches and
                  embroidery information professionally.
                </p>
              </div>

              {/* RIGHT */}
              <div className="ev-side-section">
                <div className="ev-card">
                  <h3>Features</h3>

                  <div className="ev-feature">
                    <FaLayerGroup />
                    <span>View embroidery stitch details</span>
                  </div>

                  <div className="ev-feature">
                    <FaClock />
                    <span>Estimate embroidery time</span>
                  </div>

                  <div className="ev-feature">
                    <FaMoneyBillWave />
                    <span>Estimate embroidery pricing</span>
                  </div>
                </div>

                <div className="ev-card">
                  <h3>Supported Formats</h3>

                  <div className="ev-formats">
                    {[
                      ".DST",
                      ".PES",
                      ".JEF",
                      ".EXP",
                      ".VP3",
                      ".HUS",
                      ".PEC",
                      ".XXX",
                    ].map((item) => (
                      <div key={item} className="ev-format">
                        {item}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* LOADING */}
          {this.state.loading && (
            <div className="ev-loading">
              <div className="ev-loader"></div>
              <p>Rendering Embroidery Design...</p>
            </div>
          )}

          {/* AFTER UPLOAD */}
          {preview && (
            <>
              {/* TOP SECTION */}
              <div className="ev-preview-layout">
                {/* IMAGE */}
                <div className="ev-preview-card">
                  <img src={preview.image} alt="preview" />
                </div>

                {/* DETAILS */}
                <div className="ev-right-section">
                  <div className="ev-card">
                    <h3>Embroidery Details</h3>

                    <div className="ev-detail">
                      <span>Stitches</span>
                      <strong>{preview.stitches + preview.jumps}</strong>
                    </div>

                    <div className="ev-detail">
                      <span>Colors</span>
                      <strong>{preview.colors}</strong>
                    </div>

                    {/* <div className="ev-detail">
                      <span>Trims</span>
                      <strong>{preview.trims}</strong>
                    </div>

                    <div className="ev-detail">
                      <span>Jumps</span>
                      <strong>{preview.jumps}</strong>
                    </div> */}

                    <div className="ev-detail">
                      <span>Width</span>
                      <strong>{this.mmToInch(preview.width)} inc</strong>
                    </div>

                    <div className="ev-detail">
                      <span>Height</span>
                      <strong>{this.mmToInch(preview.height)} inc</strong>
                    </div>
                  </div>
                </div>
              </div>

              {/* TIME FULL WIDTH */}
              <div className="ev-full-card">
                <h3>Stitch Time Estimation</h3>

                <div className="ev-slider-head">
                  <span>Machine Speed</span>

                  <span className="ev-slider-value">
                    <GiSewingNeedle /> {this.state.rpm} stitches / min
                  </span>
                </div>

                <input
                  type="range"
                  min="350"
                  max="1200"
                  step="50"
                  value={this.state.rpm}
                  onChange={(e) =>
                    this.setState({
                      rpm: Number(e.target.value),
                    })
                  }
                  className="ev-slider"
                />

                <div className="ev-result ev-result-blue">
                  <div className="ev-result-label">
                    Estimated Stitching Time
                  </div>

                  <div className="ev-result-value">
                    {(preview.stitches / this.state.rpm).toFixed(1)} min
                  </div>

                  <div className="ev-result-note">
                    Based on current machine speed setting
                  </div>
                </div>
              </div>

              {/* PRICE FULL WIDTH */}
              <div className="ev-full-card">
                <h3>Price Estimation</h3>

                <div className="ev-slider-head">
                  <span>Price Per 10,000 Stitches</span>

                  <span className="ev-slider-value">
                    ₹ {this.state.pricePer10k}
                  </span>
                </div>

                <input
                  type="range"
                  min="50"
                  max="500"
                  step="10"
                  value={this.state.pricePer10k}
                  onChange={(e) =>
                    this.setState({
                      pricePer10k: Number(e.target.value),
                    })
                  }
                  className="ev-slider"
                />

                <div className="ev-result ev-result-orange">
                  <div className="ev-result-label">
                    Estimated Production Cost
                  </div>

                  <div className="ev-result-value">
                    ₹
                    {Math.max(
                      50,
                      (
                        (preview.stitches / 10000) *
                        this.state.pricePer10k
                      ).toFixed(0),
                    )}
                  </div>

                  <div className="ev-result-note">
                    Calculated from stitch density and pricing rate
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    );
  }
}

export default EmbroideryViewer;
